import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  IconButton, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography 
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import useIsMobile from '../../useIsMobile';
import '../AssistantSettingsTheme.css';

/**
 * A text field component that can be expanded into a modal for editing larger text content
 */
const TextFieldWithModal = ({ label, value, onChange, multiline = true, rows = 3, readOnly = false, headerAction = null }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
        <TextField
          label={label}
          value={value || ''}
          onChange={onChange}
          fullWidth
          multiline={multiline}
          rows={isMobile && rows > 6 ? 6 : rows}
          InputProps={{
            readOnly,
            endAdornment: (headerAction || !readOnly) && (
              <Box sx={{ position: 'absolute', right: 8, top: 8, display: 'flex', alignItems: 'center' }}>
                {headerAction}
                {!readOnly && (
                  <IconButton
                    onClick={() => setOpen(true)}
                    className="assistantIconButtonNeutral"
                  >
                    <OpenInFullIcon />
                  </IconButton>
                )}
              </Box>
            )
          }}
        />
      </Box>
      <Dialog 
        open={open} 
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{ className: 'assistantDialogPaper' }}
      >
        <DialogTitle className="assistantDialogTitle">
          <Typography variant="h6">{label}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {headerAction}
            <IconButton
              onClick={() => setOpen(false)}
              size="small"
              className="assistantIconButtonNeutral"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <TextField
            value={value || ''}
            onChange={onChange}
            fullWidth
            multiline
            rows={isMobile ? 12 : 15}
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions className="assistantDialogActions">
          <Button onClick={() => setOpen(false)} className="assistantOutlineButton">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TextFieldWithModal;
